var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-list-group',{staticClass:"mb-4"},[_vm._l((_vm.lotsInProcess),function(lot){return [_c('lot',{key:lot.lot_id,attrs:{"lot":lot.lot,"lot_id":lot.lot_id,"fruit_id":lot.fruit_id,"product_id":lot.product_id,"product_name":lot.product_name,"net_kilograms_sum_in":lot.net_kilograms_sum_in,"net_kilograms_sum_out":lot.net_kilograms_sum_out}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }